import { render } from "./addToPlaylistDialog.vue?vue&type=template&id=007f553b&scoped=true"
import script from "./addToPlaylistDialog.vue?vue&type=script&lang=js"
export * from "./addToPlaylistDialog.vue?vue&type=script&lang=js"

import "./addToPlaylistDialog.vue?vue&type=style&index=0&id=007f553b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-007f553b"]])

export default __exports__